import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);

  private readonly progressSubject = new BehaviorSubject<number>(0);

  private readonly textSubject = new BehaviorSubject<string>('Chargement...');

  public get isLoading$(): Observable<boolean> {
    return this.loadingSubject.asObservable();
  }

  public get progress$(): Observable<number> {
    return this.progressSubject.asObservable();
  }

  public get text$(): Observable<string> {
    return this.textSubject.asObservable();
  }

  public set text$(text: string) {
    this.textSubject.next(text);
  }

  startLoading(text: string): void {
    setTimeout(() => {
      this.loadingSubject.next(true);
      this.textSubject.next(text);
      this.progressSubject.next(0);
    }, 0);
  }

  updateProgress(progress: number): void {
    this.progressSubject.next(progress);
  }

  stopLoading(): void {
    this.loadingSubject.next(false);
    this.progressSubject.next(100);
  }
}
